var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResearch(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1862 13.1862C13.6384 12.734 14.3715 12.734 14.8236 13.1862L17.7859 16.1485C18.238 16.6006 18.238 17.3337 17.7859 17.7859C17.3337 18.238 16.6006 18.238 16.1485 17.7859L13.1862 14.8236C12.734 14.3715 12.734 13.6384 13.1862 13.1862ZM13.1862 13.1862L11.3203 11.3203M11.3203 11.3203C13.4811 9.15959 13.4811 5.65633 11.3203 3.49558C9.15957 1.33481 5.65632 1.33481 3.49558 3.49558C1.33483 5.65633 1.33483 9.15958 3.49558 11.3203C5.65632 13.4811 9.15957 13.4811 11.3203 11.3203ZM9.9702 9.56571V7.94729M8.28451 9.56571V6.26161M6.59883 9.56571V6.93588M4.91314 9.56571V5.2502",
    stroke: "currentColor",
    strokeWidth: 1.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.0a26cbad701446173dc1cc792b35654e.svg";
export { ForwardRef as ReactComponent };